
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/furusato-tokyo-support-festival",
      function () {
        return require("private-next-pages/furusato-tokyo-support-festival/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/furusato-tokyo-support-festival"])
      });
    }
  